<script>
import ListDefault from "../Utils/Page/ListDefault";

export default {
    name: "List",
    mixins: [ListDefault],
    data() {
        return {
            lang: this.$ml.get('pages.transaction'),

            filter: {
                user_id: { value: null, type: 'text'},
                braintree_id: { value: null, type: 'text'},
            },
            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'user_id', is_sort: true, classes: 'text-l' },
                { key: 'subscribe_id', is_sort: true, classes: 'text-l' },
                { key: 'braintree_id', is_sort: true, classes: 'text-l' },
                { key: 'cost', is_sort: true, classes: 'text-l' },
            ],

            tableBody: {
                subscribe_id: {
                    type: 'function',
                    function: this.getSubscribeLink,
                },
                user_id: {
                    type: 'dictionary',
                    index: 'id',
                    local_index: 'user_id',
                    label: 'name',
                    dictionary: 'user_id'
                },
            },

            apiList: this.$store.getters.getApiUrl('transaction'),
            pageRoute: 'transaction',
            pageRouteCreate: 'transaction.create',
            pageRouteEdit: 'transaction.edit',
        }
    },
    mounted() {
        this.getDictionaries().then(({data}) => {
            this.dictionaries = data.dictionaries
        })
    },
    methods: {
        getSubscribeLink(item) {
            let link = null
            let text = null
            if (!item.subscribe_id && !item.gift_id && !item.concierge_id && !item.artipro_membership_id) {
                return null
            }
            if (item.artipro_membership_id) {
                text = 'ARTIPRO Membership ID' + item.artipro_membership_id
                link = this.$router.resolve({ name: 'artiProMembership.edit', params: {id: item.subscribe_id}})
            }

            if (item.subscribe_id) {
                text = 'Membership ID' + item.subscribe_id
                link = this.$router.resolve({ name: 'subscription.edit', params: {id: item.subscribe_id}})
            }
            if (item.gift_id) {
                text = 'Gift ID' + item.gift_id
                link = this.$router.resolve({ name: 'subscription_gift.edit', params: {id: item.gift_id}})
            }
            if (item.concierge_id) {
                text = 'Concierge ID' + item.concierge_id
                link = this.$router.resolve({ name: 'concierge_service.edit', params: {id: item.concierge_id}})
            }

            return '<a class="link" href="'+link.href+'" target="_blank">'+text+'</a>'
        }
    }
}
</script>

<style scoped>

</style>
